/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Create_Event_Group_MenuInputs */

const en_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Event Group...`)
};

const fr_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer un groupe d'evenements...`)
};

const de_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe erstellen...`)
};

const it_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea gruppo di eventi...`)
};

const ru_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать группу событий...`)
};

const es_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear grupo de eventos...`)
};

const zh_cn2_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建事件组...`)
};

const ja_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループを作成...`)
};

const hi_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप बनाएं...`)
};

const pt_pt2_markers_create_event_group_menu = /** @type {(inputs: Markers_Create_Event_Group_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar grupo de eventos...`)
};

/**
* | output |
* | --- |
* | "Create Event Group..." |
*
* @param {Markers_Create_Event_Group_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_create_event_group_menu = /** @type {((inputs?: Markers_Create_Event_Group_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Create_Event_Group_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_create_event_group_menu(inputs)
	if (locale === "de") return de_markers_create_event_group_menu(inputs)
	if (locale === "it") return it_markers_create_event_group_menu(inputs)
	if (locale === "ru") return ru_markers_create_event_group_menu(inputs)
	if (locale === "es") return es_markers_create_event_group_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_create_event_group_menu(inputs)
	if (locale === "ja") return ja_markers_create_event_group_menu(inputs)
	if (locale === "hi") return hi_markers_create_event_group_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_create_event_group_menu(inputs)
	return en_markers_create_event_group_menu(inputs)
});